(function () {
  "use strict";

  brandResource.$inject = ['$resource', 'errorHandler'];
  angular
    .module('branding')
    .factory('brandResource', brandResource);

  function brandResource($resource, errorHandler) {

    var brandResource = $resource(mfConfig.accountBaseUrlSegment + '/branding');
    var s3Resource = $resource(mfConfig.gaviotaApiBaseUrlSegment + '/contentfile/s3');

    brandResource.prototype.load = function load(resultCb, errorCb) {
      return brandResource.get(resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    brandResource.prototype.update = function update(params, resultCb, errorCb) {
      return brandResource.save(params, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    brandResource.prototype.contentFile = function contentFile(params, resultCb, errorCb) {
      return s3Resource.save(params, resultCb || angular.noop, errorHandler.defaultServerErrorHandler(errorCb));
    };

    return new brandResource;
  }

})();
